import React from 'react';

const PeopleIcon = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1476 4.84711C12.1076 4.84044 12.0609 4.84044 12.0209 4.84711C11.1009 4.81377 10.3676 4.06044 10.3676 3.12711C10.3676 2.17377 11.1342 1.4071 12.0876 1.4071C13.0409 1.4071 13.8076 2.18044 13.8076 3.12711C13.8009 4.06044 13.0676 4.81377 12.1476 4.84711Z"
      stroke="#48FFBF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4609 9.70042C12.3743 9.85376 13.3809 9.69376 14.0876 9.22042C15.0276 8.59376 15.0276 7.56709 14.0876 6.94042C13.3743 6.46709 12.3543 6.30709 11.4409 6.46709"
      stroke="#48FFBF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.12753 4.84711C4.16753 4.84044 4.2142 4.84044 4.2542 4.84711C5.1742 4.81377 5.90753 4.06044 5.90753 3.12711C5.90753 2.17377 5.14086 1.4071 4.18753 1.4071C3.2342 1.4071 2.46753 2.18044 2.46753 3.12711C2.4742 4.06044 3.20753 4.81377 4.12753 4.84711Z"
      stroke="#48FFBF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.81421 9.70042C3.90088 9.85376 2.89421 9.69376 2.18754 9.22042C1.24754 8.59376 1.24754 7.56709 2.18754 6.94042C2.90088 6.46709 3.92088 6.30709 4.83421 6.46709"
      stroke="#48FFBF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.14755 9.82715C8.10755 9.82048 8.06089 9.82048 8.02089 9.82715C7.10089 9.79382 6.36755 9.04048 6.36755 8.10715C6.36755 7.15381 7.13422 6.38715 8.08755 6.38715C9.04089 6.38715 9.80755 7.16048 9.80755 8.10715C9.80089 9.04048 9.06755 9.80048 8.14755 9.82715Z"
      stroke="#48FFBF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.20756 11.9272C5.26756 12.5538 5.26756 13.5805 6.20756 14.2072C7.27423 14.9205 9.0209 14.9205 10.0876 14.2072C11.0276 13.5805 11.0276 12.5538 10.0876 11.9272C9.02756 11.2205 7.27423 11.2205 6.20756 11.9272Z"
      stroke="#48FFBF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PeopleIcon;
